module.exports = __webpack_public_path__ + "static/img/numbers_card_local.b88dcb51.png";